import React from "react";

import Title from "../../../components/Title";
import Editor from "../../../components/Editor";
import Section from "../../../components/Section";

import style from "./style.module.css";

export default function TextBlock({ title = "", tag = "h1", align, text = "", wrap_width = 0 }) {
    return (
        <Section className={style.textBlock}>
            <div className={`${style.textBlockWrap} ${wrap_width === 1 ? style.wrapWidth : ""}`}>
                <div className={style.sectionRow}>
                    {
                        title !== "" && (
                            <div className={style.sectionHeader}>
                                <Title align={align} className="fontTeko" tag={tag}>{title}</Title>
                            </div>
                        )
                    }
                    {
                        text !== "" && (
                            <div className={style.sectionBody}>
                                <Editor text={text} />
                            </div>
                        )
                    }
                </div>
            </div>
        </Section>
    )
}